import React, { useState } from 'react';
import { OrderSummary } from './OrderSummary';
import { CheckoutForm } from './CheckoutForm';
import { TrustSection } from './TrustSection';
import { ShieldCheckIcon } from 'lucide-react';
export function CheckoutPage() {
  const [selectedPackage, setSelectedPackage] = useState('performance');
  const [quantity, setQuantity] = useState(1);
  const packagePrices = {
    starter: 39.99,
    performance: 69.99,
    executive: 99.99
  };
  const calculateSubtotal = () => {
    return packagePrices[selectedPackage] * quantity;
  };
  const calculateTax = () => {
    return calculateSubtotal() * 0.21; // 21% VAT (common in EU)
  };
  const calculateTotal = () => {
    return calculateSubtotal() + calculateTax();
  };
  return <div className="min-h-screen w-full bg-gradient-to-b from-indigo-900 to-indigo-700 text-gray-800" data-id="element-75">
      <div className="container mx-auto px-4 py-8 max-w-6xl" data-id="element-76">
        {/* Header */}
        <header className="text-center mb-8" data-id="element-77">
          <h1 className="text-2xl md:text-3xl font-bold text-white flex items-center justify-center gap-2" data-id="element-78">
            <ShieldCheckIcon className="h-6 w-6" data-id="element-79" />
            NightPhase Secure Checkout
          </h1>
          <p className="text-indigo-100 mt-2" data-id="element-80">
            30-night satisfaction guarantee • Free EU shipping
          </p>
        </header>
        <div className="flex flex-col lg:flex-row gap-8" data-id="element-81">
          {/* Order Summary */}
          <div className="lg:w-2/5" data-id="element-82">
            <OrderSummary selectedPackage={selectedPackage} setSelectedPackage={setSelectedPackage} quantity={quantity} setQuantity={setQuantity} subtotal={calculateSubtotal()} data-id="element-83" />
          </div>
          {/* Checkout Form */}
          <div className="lg:w-3/5" data-id="element-84">
            <CheckoutForm subtotal={calculateSubtotal()} tax={calculateTax()} total={calculateTotal()} data-id="element-85" />
          </div>
        </div>
        {/* Trust Section */}
        <div className="mt-12" data-id="element-86">
          <TrustSection data-id="element-87" />
        </div>
      </div>
    </div>;
}